<template>
  <div class="IriadeCarouselPageFormBlock" :style="{'align-items': (input.config.centered) ? 'centered' : 'baseline'}">
    <h1 class="header primary--text mb-10"
        style="align-self: center">{{input.label}}</h1>
    <div v-for="(page, i) in content.config.pages"
         :key="page.name"
         style="width: 100%;">
      <!--TODO: refactor nullsafe accessor-->
      <component :is="page.component"
                 :form-data="$attrs['form-data']"
                 :carousel-data="$attrs['carousel-data']"
                 :input="page.props"
                 :block="page.props"
                 :input-index="i"
                 :errors="errors && errors[content.name] && errors[content.name][page.props.name]"
                 @input="setAnswer(i, $event)"/>
    </div>
    <div
      v-if="nextPageDyn !== null"
      style="align-self: center">
      <v-btn class="primary"
             :disabled="disabled"
             @click="nextStep()"
             :style="{display: (!isFinal) ? 'block' : 'none'}">{{(nextPageDyn === 'fin') ? "Fin" : "Suite"}}</v-btn>
    </div>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'
  import Vue from 'vue'
  import IriadeApplicationMediaBlock
    from "@/components/Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {
    components: {IriadeApplicationMediaBlock},
    mixins: [IriadeFormBlockMixin],

    props: ['input'],

    computed: {
      content () {
        return {
          ...this.input,
          config: {
            ...this.input.config,
            pages: this.input.config.contents.map(content => ({
              props: content,
              component: () => import(`components/Iriade/Blocks/IriadeFormBlock/Inputs/${content.type}FormBlock`).catch(_ => import(`components/Iriade/Blocks/${content.type}/${content.type}`))
            }))
          },
        };
      },
    },

    data () {
      return {
        formData: {},
        lambada: null,
        nextPageDyn: null,
        disabled: true,
        isFinal: false,
      }
    },

    methods: {
      computeNextPageLambda() {
        return eval(this.input.config.nextPageLambda);
      },

      computedNextPage() {
        let nextPage = this.input.config.nextPage;
        if (this.input.config.nextPageByLambda) {
          nextPage = this.lambada(this.formData, this.$attrs['carousel-data']['pagesDatas']);
        }
        return nextPage;
      },

      isDisabled() {
        let acc = false;
        for (let content in this.input.config.contents) {
          if (this.input.config.contents[content].validation && this.input.config.contents[content].validation.includes('required')) {
            let tmp = this.formData[this.input.config.contents[content].name];
            acc = acc || tmp === undefined || tmp === null;
          }
        }
        return acc;
      },

      nextStep() {
        this.$emit('input', this.formData);
        this.$emit('nextStep', this.nextPageDyn);
      },

      setAnswer(i, $event) {
        this.formData[this.input.config.contents[i].name] = $event;
        this.nextPageDyn = this.computedNextPage();
        this.disabled = this.isDisabled();
      },
    },

    mounted() {
      for (let content in this.input.config.contents) {
        let name = this.input.config.contents[content].name;
        if (name) {
          this.formData[name] = null;
        }
      }
      this.lambada = this.computeNextPageLambda();
      this.nextPageDyn = this.computedNextPage();
      this.disabled = this.isDisabled();
      this.isFinal = this.input.config.isFinal;
    },
  }
</script>

<style lang="scss"
       type="text/scss">
  .IriadeCarouselPageFormBlock {
    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
    }

    .step h1 {
      text-align: center;
    }

    .end {
      font-size: 18px;
      padding-left: 30px;
      padding-right: 30px;
    }

    .header {
      font-size: 22px;
    }

    .label:before {
      color: #ccc;
      content: open-quote;
      font-size: 40px;
      line-height: 0.1em;
      margin-right: 0.25em;
    }

    .label {
      padding: 30px 20px;
      font-size: 18px;
      font-weight: 600;
      max-width: 650px;
    }

    .answer-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 20px;
      background: #FFF;
      border-radius: 12px;
      max-width: 600px;
      margin: 0 30px 30px 30px;
    }
  }
</style>
